// Client-side Sentry initialisation.
//
// Next executes this before any other client code, which is why Sentry.init
// lives here rather than in pages/_app.js: errors thrown while the app bundle
// is still evaluating would otherwise go unreported.
//
// The DSN comes from the runtime config global rather than a NEXT_PUBLIC_*
// constant. pages/_document.js writes that global from the container's
// environment in an inline <script> placed first in <Head>, so the parser has
// executed it before any deferred bundle — including this one — runs. See
// lib/config.ts for why the app avoids build-time inlining for these values.
;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import * as Sentry from '@sentry/nextjs'
import { getPublicConfig } from './lib/config'

const config = getPublicConfig()

if (config.sentry_dsn) {
  Sentry.init({
    dsn: config.sentry_dsn,
    environment: config.env,

    // Errors only. See the matching note in instrumentation.ts — browser spans
    // are already exported to Tempo by lib/browser-tracing.ts, and the
    // tracesSampleRate the old @sentry/browser init passed never took effect.

    // Third-party script injected into some users' browsers (not served by us;
    // /executors/200.js 404s). It wraps every XHR and reads `response.M_ID`
    // unguarded, flooding Sentry with "reading 'M_ID'" TypeErrors
    // (DASHBOARDS-HQ et al.). denyUrls matches the innermost frame, so real
    // errors that merely pass through zone.js's XHR wrapping still report.
    denyUrls: [/\/executors\/\d+\.js/],
  })
}

// The SDK's build step fails an explicit check without this export. It only
// fires on App Router navigations, so it is inert in this Pages Router app —
// it is here to keep the check satisfied and to be correct if an app/ dir is
// ever added.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
